import React from 'react';
import { translate } from '../Services/translation'
import BuyButton from '../Containers/BuyButton.container';

const ProductCard = ({ product, onClick }) => {
    const cardBaseClass = `product-card`
    const isInStock = product.showBuyButton && product.isStockBalanceAboveLimit
    let tags = product.tags || product.productTags;

    if (typeof tags === 'string')
        tags = JSON.parse(tags)

    if (typeof product.usps === 'string')
        product.usps = JSON.parse(product.usps)    

    return (
        <article className={`${cardBaseClass}`} onClick={() => onClick && onClick(product)}>        
            <figure className={`${cardBaseClass}__figure`}>
                <img className={`${cardBaseClass}__image`} itemProp="image" src={product.imageSrc} alt={product.title} loading='lazy' />
                {
                    tags && (
                        <div className={`${cardBaseClass}__tags`}>
                            {
                                tags.map((tag, index) =>
                                    <span className={`${cardBaseClass}__tag ${cardBaseClass}__tag--${ tag.style || tag.Style}`} key={index}>{ tag.label || tag.Label }</span>
                                )
                            }
                        </div>
                    )
                }
                {
                    product.webTagSrc && (
                        <img className='product-card__webtag' src={product.webTagSrc} alt='webtag' loading='lazy' />
                    )
                }
            </figure>
            
            <a href={product.linkUrl} itemProp="url" className={`${cardBaseClass}__link`}></a>

            <div className={`${cardBaseClass}__content`}>
                <h3 itemProp="name" className={`${cardBaseClass}__title`}>{product.title}</h3>

                <div className={`${cardBaseClass}__status`}>
                    <div className={`${cardBaseClass}__stock`}>
                        {
                            isInStock
                                ? (
                                    <span className="stock-status-preview__status stock-status-preview__status--in-stock">
                                        {
                                            product.stockStatusDescription
                                        }
                                    </span>
                                )
                                : (
                                    <span className="stock-status-preview__status stock-status-preview__status--out-of-stock">
                                        {
                                            product.stockStatusDescription
                                        }
                                    </span>
                                )
                        }

                    </div>

                    <div className={`${cardBaseClass}__rating`}>
                        <div data-bv-show="inline_rating" data-bv-product-id={product.reference}></div>
                    </div>
                </div>

                <ul className={`${cardBaseClass}__usp-list`}>
                    {
                        product.usps && product.usps.map((usp, index) => 
                            <li className={`${cardBaseClass}__usp-list-item`} key={index} title={usp}>
                                {
                                    usp
                                }
                            </li>
                        )
                    }
                </ul>
            </div>
            
            <div className={`${cardBaseClass}__footer`}>
                {
                    <div className={`${cardBaseClass}__price`}>
                        {product.campaignPrice
                                ? (
                                    <>
                                        <span className={`${cardBaseClass}__price--campaign`}>{product.campaignPrice}</span>
                                        <span className={`${cardBaseClass}__price--original`}>{product.recommendedPrice}</span>
                                    </>
                                )
                                : (
                                    <span className={`${cardBaseClass}__price--recommended`}>{product.recommendedPrice}</span>
                                )
                        }
                        {product.lowestPriceNDays && (
                            <div className={`${cardBaseClass}__price--lowest`}>
                                {product.lowestPriceNDays}
                            </div>
                        )}
                    </div>
                }

                {
                    // TODO add compairison
                }

                {
                    product.showBuyButton && product.linkUrl != null && product.linkUrl != "" &&  (
                        <BuyButton {...{ 
                            isShowMore: !isInStock,
                            label: isInStock ? translate('product.buy.small') : translate('product.readMore'),
                            articleNumber: product.reference,
                            cssClass: `button button--buy button--buy-small`,
                            href: product.linkUrl 
                        }} />
                    )
                }
            </div>
        </article>
    )
}

export default ProductCard;